export type StakeDrafts = Record<string,string>;
export type StakeRow = {queue_id:string; revision:string; runner:string; market_type?:string; editable:boolean};
export const stakeDraftKey=(userId:string,paper:boolean)=>'betbuilder:stake-drafts:v1:'+userId+':'+(paper?'private-paper':'admin');
export function readStakeDrafts(storage:Storage,key:string):StakeDrafts {
  try {const v=JSON.parse(storage.getItem(key)||'{}');
    return v&&typeof v==='object'&&!Array.isArray(v)?Object.fromEntries(Object.entries(v).filter(([,a])=>typeof a==='string')) as StakeDrafts:{};
  } catch {return {};}
}
export function retainUnsaved(current:StakeDrafts,snapshot:StakeDrafts,saved:string[]):StakeDrafts {
  const next={...current};for(const id of saved)if(next[id]===snapshot[id])delete next[id];return next;
}
export async function saveStakeGrid(drafts:StakeDrafts,rows:StakeRow[],request:(path:string,body:any)=>Promise<any>) {
  const saved:string[]=[],errors:string[]=[],entries=Object.entries(drafts);
  const invalid=entries.filter(([,raw])=>{const n=Number(raw);return !raw.trim()||!Number.isFinite(n)||n<1||n>100000||Math.abs(n*100-Math.round(n*100))>1e-6;});
  if(invalid.length)return {saved,errors:invalid.map(([id])=>(rows.find(r=>r.queue_id===id)?.runner||id)+': enter $1–$100,000 with at most two decimal places. No stakes were saved.')};
  for(const [id,raw] of entries){
    const row=rows.find(r=>r.queue_id===id);
    if(!row?.editable){errors.push((row?.runner||id)+': no longer editable; this draft was not saved.');continue;}
    try {await request('/api/rolling/simple-bsp/bet-override',{queue_id:id,expected_revision:row.revision,action:'stake',stake:Number(raw)});saved.push(id);}
    catch(e:any){errors.push(row.runner+' '+(row.market_type||'WIN')+': '+(e?.message||'Save failed. Check status before retrying.'));}
  }
  return {saved,errors};
}
